import React, { Component } from "react";
import { Row, Col, Button, Divider, Empty } from "antd";
import { connect } from "react-redux";
import { UserAction } from "../../store/actions";
import { AiOutlinePlus, AiOutlineSearch } from "react-icons/all";
import AddressCard from "../../components/EmployeCard/plantInfoCard";
import CustomModal from "../../components/modals/customModal";
import TextInput from "../../components/input/TextInput";
import { formatToNumber } from "../../config/utils";
import {
  MdLocationPin,
  HiPhone,
  MdEmail,
  FaAddressCard,
  BiCurrentLocation
} from "react-icons/all";
import Select, { components } from "react-select";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import { EMAIL_REGX } from "../../config/variables";
import LoaderGif from "../../assets/images/ie_loader.gif";
// import { color, style } from "@mui/system";
import PlacesInput from "../../components/placeInput";
class Addresses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        per_page: 12,
        current_records: 0,
        total_pages: 0,
        total_records: 0,
      },
      isOpenAddress: false,
      addressPayload: {
        email: "",
        zipcode: "",
        phone: "",
        address: "",
        geocode: [],
        name: "",
        contact_person: ""
      },
      addressError: {
        emailError: "",
        zipcodeError: "",
        phoneError: "",
        addressError: "",
        nameError: "",
        contactPersonError: ""
      },
      address: [],
      addressValue: "",
      isUpdate: false,
      locationVal: "",
    };
  }
  componentDidMount() {
    const { getAddresses } = this.props;
    getAddresses(this.state.filter, null);
  }

  componentDidUpdate(preProps, preState) {
    const { getAddresses } = this.props;
    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          total_records: this.props?.metaData?.total_records,
          current_records: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }
    if (
      preState.filter.page !== this.state.filter.page ||
      preState.filter.search !== this.state.filter.search ||
      preState.filter.status !== this.state.filter.status
    ) {
      getAddresses(this.state.filter, null);
    }
  }

  onSubmit = () => {
    const { createAddress, updateAddress } = this.props;
    const { isUpdate, addressPayload, addressError, addressValue } = this.state;
    const err = { ...addressError };
    const addressObj = {
      zipcode: addressPayload?.zipcode,
      address: addressValue,
      phone: addressPayload.phone,
      email: addressPayload.email,
      name: addressPayload.name,
      contact_person: addressPayload?.contact_person

    }
    console.log("rtye", addressError);
    if (
      !addressValue?.trim()?.length ||
      !addressPayload?.zipcode?.toString()?.trim()?.length ||
      // !addressPayload?.contact_person?.toString()?.trim()?.length ||
      !addressPayload.name.trim().length ||
      !addressPayload?.phone?.toString()?.trim()?.length ||
      addressPayload?.phone?.toString()?.trim()?.length < 10 ||
      !EMAIL_REGX.test(addressPayload.email)
    ) {
      if (!addressValue?.trim()?.length) {
        err.addressError = "Location Address is required";
      }

      if (!addressPayload?.name?.trim().length) {
        err.nameError = "Location name is required";
      }
      if (!addressPayload?.zipcode.toString()?.trim()?.length) {
        err.zipcodeError = "Zipcode is required";
      }
      if (!addressPayload?.phone?.toString()?.trim()?.length) {
        err.phoneError = "Phone number is required";
      }
      if (addressPayload?.phone?.toString()?.trim()?.length < 10) {
        err.phoneError = "Phone number is required";
      }
      if (!EMAIL_REGX.test(addressPayload.email)) {
        err.emailError = "Email is required";
      }
      // if (!addressPayload?.contact_person?.trim().length) {
      //   err.contactPersonError = "Contact Person is required";
      // }

      this.setState({
        addressError: err,
      });
      return;
    }
    // }
    if (!isUpdate) {
      createAddress(
        addressObj,
        () =>
          this.setState({
            isOpenAddress: false,
          }),
        this.state.filter
      );
      return;
    }
    updateAddress(
      this.state.addressPayload.id,
      null,
      addressObj,
      () =>
        this.setState({
          isOpenAddress: false,
        })
    );
  };
  onHandleChanged = (e) => {
    this.setState({
      addressPayload: {
        ...this.state.addressPayload,
        [e.target.name]: e.target.value,
      },
      addressError: {
        ...this.state.addressError,
        [`${e.target.name}Error`]: "",
      },
    });
  };
  handleChange = () => { };
  onChangeLocation = (e) => {
    if (e) {
      const obj = {
        address: e,
        key: "AIzaSyDZ0ipZ-kLwiyOvIUINdg3X0Z-JOyl8V_k",
      };
      const qureyParams = new URLSearchParams(obj).toString();
      try {
        fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?${qureyParams}`
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("data==>", data);
            this.setState({
              address: data.results,
            });
          });
      } catch (Error) {
        console.log("ee==>", Error);
      }
    }
  };
  currentPage = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  previousPage = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  checkZipCode = () => {
    this.state.address.forEach((item) => {
      for (let address of item.address_components) {
        if (address.types.includes("postal_code")) {
          console.log(
            "address_postal==>",
            address.types.includes("postal_code"),
            address.long_name
          );
          // this.state.addressPayload.zipcode=address.long_name
          this.state.addressPayload.zipcode = address.long_name;
          this.setState({
            addressPayload: this.state.addressPayload,
            addressError: { ...this.state.addressError, zipcodeError: "" },
          });
          return;
          // this.contractorAddress.zipcode = address.long_name;
        } else {
          this.setState({
            addressPayload: { ...this.state.addressPayload, zipcode: "" },
          });
        }
      }
    });
  };
  render() {

    console.log("this.state.addressValue", this.state.addressValue)

    const { addresses, metaData, isLoadingAddress } = this.props;
    const {
      isOpenAddress,
      addressPayload: { contact_person, email, zipcode, phone, name },
      addressError: {
        emailError,
        addressError,
        phoneError,
        zipcodeError,
        nameError,
        contactPersonError
      },
      isUpdate,
      address,
    } = this.state;
    const classoptions = this.state.address.map((item) => {
      return { value: item, label: item.formatted_address };
    });
    console.log("checkingLength ===>", phone);
    const DropdownIndicator = (props) => {
      return (
        components.DropdownIndicator && (
          <components.DropdownIndicator {...props}>
            <AiOutlineSearch />
          </components.DropdownIndicator>
        )
      );
    };
    console.log("metaData====>", this.state.locationVal);
    return (
      <Row>
        <Col
          xl={24}
          lg={24}
          xs={24}
          sm={24}
          md={24}
          style={{
            minHeight: "calc(100vh - 4.8em)",
            width: "100%",
            padding: "1.2rem",
            background: "white",
            width: "100%",
            marginTop: "22px",
            marginBottom: "80px",
            boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
            border: "1px solid #f7f7f7",
          }}
        >
          <Row justify="space-between" className="st-table-header">
            <Col xl={24} lg={24} xs={24} sm={24} md={24}>
              <Row justify="space-between">
                <Col xl={12} lg={12} xs={24} sm={24} md={12}>
                  <h5 className="text-left"> Address Book</h5>
                </Col>
                <Col>
                  <span className="pointer-cursor">
                    <AiOutlinePlus
                      size="20"
                      onClick={() =>
                        this.setState({
                          isOpenAddress: true,
                          addressPayload: {
                            email: "",
                            zipcode: "",
                            contact_person: "",
                            phone: "",
                            address: "",
                            geocode: [],
                            name: "",
                          },
                          addressError: {
                            emailError: "",
                            zipcodeError: "",
                            phoneError: "",
                            addressError: "",
                            contactPersonError: ""
                          },

                          addressValue: "",
                          isUpdate: false,
                        })
                      }
                    />
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="start" gutter={[20, 20]} style={{ marginTop: "30px" }}>
            {!!addresses?.length ? (
              (addresses || []).map((item) => {
                return (
                  <Col xl={6} sm={12} xs={24} md={8}>
                    <AddressCard
                      bussinessName={"Address"}
                      data={item}
                      {...this.props}
                      filter={this.state.filter}
                      onChangeUpdate={(e, item) => {
                        this.setState({
                          isOpenAddress: true,
                          isUpdate: true,
                          addressPayload: e,
                          addressValue: item,
                          addressError: {
                            emailError: "",
                            zipcodeError: "",
                            phoneError: "",
                            addressError: "",
                            contactPersonError: ""
                          },
                        });
                      }}
                    />
                  </Col>
                );
              })
            ) : (
              <>
                <Col span={24} className="text-center">
                  {isLoadingAddress && (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  )}
                  {!isLoadingAddress && (
                    <Empty description={"Nothing to show right now."} />
                  )}
                </Col>
              </>
            )}
          </Row>
          {!!addresses?.length && (
            <Col
              xs={24}
              sm={24}
              md={23}
              lg={23}
              xl={23}
              style={{ marginTop: "20px", marginBottom: "20px" }}
            >
              <Row
                gutter={[5, 0]}
                xs={24}
                sm={24}
                md={23}
                lg={23}
                xl={23}
                justify="start"
              >
                <Col className="tablePagination">
                  {`Displaying ${this.state.filter?.page !== this.state.filter.total_pages
                    ? this.state.filter?.current_records *
                    this.state.filter?.page
                    : this.state.filter?.total_records
                    } of ${this.state.filter?.total_records}`}
                  <Button
                    type="link"
                    icon={<BsChevronLeft color="#686868" size={15} />}
                    onClick={this.previousPage}
                    disabled={
                      this.state.filter?.current_page === 1 ||
                      this.state?.filter?.page <= 1
                    }
                  />
                  {this.state?.filter.page}
                  <Button
                    type="link"
                    icon={<BsChevronRight color="#686868" size={15} />}
                    onClick={this.currentPage}
                    disabled={
                      this.state?.filter?.total_pages ===
                      this.state?.filter?.page
                    }
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Col>
        <CustomModal
          className="address-modal"
          visible={isOpenAddress}
          onCancelModal={() =>
            this.setState({
              isOpenAddress: false,
            })
          }
          footer={[
            this.props.isLoading ? (
              <img src={LoaderGif} height={"60"} width={"60"} />
            ) : (
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={this.onSubmit}
              >
                Save
              </Button>
            ),
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">
              {isUpdate ? "Edit Address" : "Add Address"}
            </h5>
            <Divider />
          </Col>
          <Col span={24} className="pointer-cursor">
            <Row justify="center">
              <Col span={22}>
                <form>
                  <Row justify="center" gutter={[5, 0]}>

                    <Col span={24} style={{ marginBottom: "1rem" }} >
                      <TextInput
                        label="Location Name/Label"
                        name="name"
                        onChange={this.onHandleChanged}
                        value={name}
                        required
                        Icon={FaAddressCard}
                        color="grey"
                        style={{ border: "none", fontSize: "95%" }}
                        maxLength={50}
                      />
                    </Col>


                    <Col span={24} style={{ marginBottom: "1rem" }} >
                      <TextInput
                        label="Contact Person Name"
                        name="contact_person"
                        onChange={this.onHandleChanged}
                        value={contact_person}
                        Icon={FaAddressCard}
                        color="grey"
                        style={{ border: "none", fontSize: "95%" }}
                        maxLength={50}
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ textAlign: "start" }}
                        >
                          {" "}
                          <span
                            className="danger-color"
                            style={{ fontSize: "80%" }}
                          >
                            {contactPersonError && contactPersonError}
                          </span>
                        </Col>
                      </Row>
                    </Col>




                    <Col xl={24}>


                    </Col>{" "}

                    <Col span={24} className="select-categories">
                      <span
                        style={{
                          color: "#26a69a",
                          marginRight: "10px",
                          fontSize: "95%",
                        }}
                      >
                        Location Address <span className="color-orange">*</span>{" "}
                      </span>
                      <PlacesInput
                        className="userSelect"
                        value={`${this.state.addressValue}`}
                        onChange={(e) =>
                          this.setState({
                            addressValue: e.target.value,
                          })
                        }
                        onSetValue={(val) => {
                          console.log("stateVal==>", val);
                          this.setState({
                            addressValue: val.formatted_address,
                            addressPayload: {
                              ...this.state.addressPayload,
                              address: val.formatted_address,
                              geocode: [val]
                            },
                            address: [val]
                          });
                          this.checkZipCode()
                        }}
                        maxLength={50}

                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ textAlign: "start" }}
                        >
                          {" "}
                          <span
                            className="danger-color"
                            style={{ fontSize: "80%" }}
                          >
                            {addressError && addressError}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={24}>
                      {/* <TextInput
                        label="Location Name/Label"
                        name="name"
                        onChange={this.onHandleChanged}
                        value={name}
                        required
                        Icon={FaAddressCard}
                        color="grey"
                        style={{ border: "none", fontSize: "95%" }}
                        maxLength={50}
                      /> */}
                      {/* <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ marginTop: "10px" }}
                        >
                          {" "}
                          <span
                            className="danger-color"
                            style={{ fontSize: "80%" }}
                          >
                            {nameError && nameError}
                          </span>
                        </Col>
                      </Row> */}
                    </Col>




                    <Col span={24} style={{ marginBottom: "1rem" }} >
                      <TextInput
                        label="Zip/Postal Code"
                        name="zipcode"
                        onChange={this.onHandleChanged}
                        value={zipcode}
                        required
                        Icon={MdLocationPin}
                        color="lightgrey"
                        style={{ border: "none", fontSize: "95%", textAlign: "start" }}
                        maxLength={50}
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ textAlign: "start" }}
                        >
                          {" "}
                          <span
                            className="danger-color"
                            style={{ fontSize: "80%" }}
                          >
                            {zipcodeError && zipcodeError}
                          </span>
                        </Col>
                      </Row>
                    </Col>



                    <Col span={24} style={{ marginBottom: "1rem" }} >
                      <TextInput
                        label="Phone"
                        name="phone"
                        onChange={this.onHandleChanged}
                        value={formatToNumber(phone)}
                        required
                        Icon={HiPhone}
                        color="grey"
                        maxLength={15}
                        style={{ border: "none", fontSize: "95%" }}
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ textAlign: "start" }}
                        >
                          {" "}
                          <span
                            className="danger-color"
                            style={{ fontSize: "80%" }}
                          >
                            {phoneError && phoneError}
                          </span>
                        </Col>
                      </Row>
                    </Col>



                    <Col span={24} style={{ marginBottom: "1rem" }} >
                      <TextInput
                        label="Email"
                        name="email"
                        onChange={this.onHandleChanged}
                        value={email}
                        required
                        Icon={MdEmail}
                        color="grey"
                        style={{ border: "none", fontSize: "95%" }}
                        maxLength={50}
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ textAlign: "start" }}
                        >
                          {" "}
                          <span
                            className="danger-color"
                            style={{ fontSize: "80%" }}
                          >
                            {emailError && emailError}
                          </span>
                        </Col>
                      </Row>
                    </Col>




                  </Row>
                </form>{" "}
              </Col>
            </Row>
          </Col>
        </CustomModal>
      </Row>
    );
  }
}

function mapStateToProps(store) {
  return {
    addresses: store.UserReducer.addresses,
    metaData: store.UserReducer.metaData,
    isLoadingAddress: store.UserReducer.isLoadingAddress,
    isLoading: store?.UserReducer?.isLoading,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getAddresses: (params, cb) =>
      dispatch(UserAction.getAddressReq(params, cb)),
    updateAddress: (id, route, payload, cb) =>
      dispatch(UserAction.updateAddressReq(id, route, payload, cb)),
    getGeoLocation: (payload, cb) =>
      dispatch(UserAction.getGeoLocationReq(payload, cb)),
    createAddress: (payload, cb, params) =>
      dispatch(UserAction.createAddressReq(payload, cb, params)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Addresses);
